import Footer from "../../components/footer/footer"
import Header from "../../components/header/header"
import { customScript } from "../../common/customscript";
import { useEffect } from "react";
import ForgotSection from "../../components/forgot/forgetsection";
import SearchModel from "../../components/search_model/search";

const Forgot = () => {
    useEffect(() => {
        customScript()
    }, [])

    return (
        <>
            <Header />
            <ForgotSection />
            <Footer />
            <SearchModel/>
        </>
    )
}

export default Forgot